import React, { useEffect } from 'react'
import { observer } from 'mobx-react'

import Modal from 'components/Modal'
import VideoContent from 'components/VideoContent'
import { SMALL_MODAL } from 'consts/modalStyles'
import { useWindowSize } from 'hooks'

import VideoModalStore from '../../stores/VideoModalStore'

const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: '95vw',
    maxHeight: '80vh',
  },
}

function VideoModal({ location, history, match }) {
  const [windowSize] = useWindowSize()

  const state = location?.state?.backgroundPage?.state

  useEffect(() => {
    if (!VideoModalStore.currentVideo) {
      VideoModalStore.setVideo({
        currentVideo: {
          postId: match.params.postId,
          provider: match.params.provider,
        },
        changeBackground: false,
      })
    }
  }, [match])

  function clearUrlVideo() {
    const { pathname, search, hash } = location?.state?.backgroundPage ?? {}

    history.push(`${pathname}${search}${hash}`)
  }

  function handleClose() {
    VideoModalStore.clearVideo()
    clearUrlVideo()
  }

  return (
    <div className="VideoModal">
      <Modal
        isOpen={!!VideoModalStore.currentVideo}
        styleModal={windowSize <= 600 ? MODAL_STYLE : null}
        onRequestClose={handleClose}
      >
        <VideoContent
          video={VideoModalStore.currentVideo}
          closeVideoPlayer={handleClose}
          minimalVersion={state?.minimalVersion}
        />
      </Modal>
    </div>
  )
}

export default observer(VideoModal)
